import { ComputerState } from '@/constant/computerType'

export const state: ComputerState = {
  navConfig: {
    coid:'',
    id:'',
    _id:'',
    datas: [],
    is_show_search: '1',
    login_switch: '',
    logo_url: ''
  },
  footerConfig: {
    default_name:'default',
    basecolor: '',
    template_list:{
      default: {
        copyright: ''
      },
      template1: {
        copyright: '',
        nav_lists: []
      },
      template2: {
        copyright: '',
        qq_url: '',
        sina_url: '',
        wechat_img: '',
        show_qq: false,
        show_sina: false,
        show_wechat: false,
        text1: '',
        text2: '',
      }
    }

  },
  pageDesignConfig: [
    {
      addable: false,
      deleteable: true,
      dragable: true,
      editable: true,
      help_href: "",
      id: '',
      is_modified: false,
      order_weight: 2,
      sub_list: [ ],
      title: '轮播图',
      type: 'pc_slideshow',
      type_title: '图片广告',
    },
  ],
  pageHeaderConfig:{
    preview:false,
    submit:false
  }
}
